import React from 'react';
import { motion } from 'framer-motion';
interface HeroProps {
  revealDelay?: number;
}
export function Hero({
  revealDelay = 0
}: HeroProps) {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-bp-bg" data-id="element-51" data-mp="ehti5t5oavm8">
      {/* Dramatic side light — subtle depth, no color, no gradient feel */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(120% 90% at 18% 50%, rgba(40,40,40,0.55) 0%, rgba(10,10,10,0) 55%)'
    }} aria-hidden="true" data-id="element-52" data-mp="4njqyesgw3d3" />

      {/* Content */}
      <motion.div className="relative z-10 text-center px-6 md:px-20 w-full" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: revealDelay
    }} data-id="element-53" data-mp="sa9rtct2xrw4">
        <h1 className="font-display text-7xl md:text-9xl lg:text-[12rem] text-bp-text tracking-[0.15em] uppercase mb-8 text-center pl-[0.15em] leading-none" data-id="element-54" data-mp="3825ywscu0bmf">
          BAJO PERFIL
        </h1>

        <div className="space-y-2 mt-4 md:mt-8" data-id="element-55" data-mp="3o85af8w3tx3i">
          <p className="font-body font-light text-bp-text2 text-base md:text-lg tracking-[0.2em] uppercase mb-4" data-id="element-56" data-mp="3o6u534n0ghaa">
            Street Food
          </p>
          <p className="font-body font-light text-bp-text2 text-sm md:text-base" data-id="element-57" data-mp="3e8mtz2fektg7">
            Ingredientes reales. Hecho al momento.
          </p>
          <p className="font-body font-light text-bp-text2 text-sm md:text-base" data-id="element-58" data-mp="30gq1gx9tohja">
            Pasto, Colombia.
          </p>
        </div>
      </motion.div>
    </section>;
}